import buildingImage from './images/building.svg';
import offerImage from './images/offer.svg';
import style from './style.css';

/**
 * Где заглушка: основная галерея, превью оффера (своя картинка на белом), фото корпуса (без подписи)
 * или карточка похожего здания (картинка оффера на сером, уменьшенная)
 */
export type TNoPhotoVariant = 'gallery' | 'offer' | 'block' | 'similar';

export interface INoPhotoProps {
  variant: TNoPhotoVariant;
}

/**
 * «Нет фото» — заглушки монолита (`.cf-photo-gallery_empty`, `offer__gallery-empty`, `logo--empty` корпусов,
 * `no-photo.png` карточки похожего)
 */
export const NoPhoto = ({ variant }: INoPhotoProps) => (
  <div className={`${style['container']} ${style[variant]}`} data-name="NoPhoto">
    <img
      className={style['image']}
      src={variant === 'offer' || variant === 'similar' ? offerImage : buildingImage}
      alt=""
    />
    {variant !== 'block' && <span className={style['text']}>Нет фото</span>}
  </div>
);
